<template>
	<div
		class="app-great-date-range-picker"
		:class="[
			{'border border-red border-md': debugMode},
			`variant-${variant}`,
		]"
	>
		<template v-if="debugMode">
			<div class="ao-p3-regular">AoGreatDateRangePicker</div>
			<pre
				class="mb-2"
				style="padding: 0.5rem; background-color: #3c3b3b; color: rgb(39, 136, 18); font-size: 12px;"
			><code>{{ {
				modelValue,
				companyTz,
				// guessedTz,
				min,
				max,
			} }}</code></pre>
		</template>
		<div :class="{'pa-2': debugMode}">
			<MainOfDateRangePicker
				:modelValue="modelValueWithoutTimezone"
				:ranges="ranges"
				:min="minValueWithoutTimezone"
				:max="maxValueWithoutTimezone"
				:startDay="personalCompanySettingStartDay"
				:label="label"
				:placeholder="placeholder"
				:error="error"
				:errorMessages="errorMessages"
				:density="density"
				:debugMode="debugMode"
				:hideDetails="hideDetails"
				:variant="variant"
				@update:modelValue="onUpdateModelValue"
			/>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'

import useMoment from '@/composables/useMoment.js'

import usePersonalCompanySettingsManager from '@/composables/managers/usePersonalCompanySettingsManager'

import MainOfDateRangePicker from './date-range-picker/MainOfDateRangePicker.vue'

const props = defineProps({

	modelValue: {
		type: [Array, String],
		default: () => (null),
	},

	ranges: {
		type: Array,
		default: () => (null),
	},

	min: {
		type: String,
	},

	max: {
		type: String,
	},

	label: {
		type: String,
	},

	placeholder: {
		type: String,
	},

	error: {
		type: Boolean,
		default: false,
	},

	errorMessages: {
		type: [Array, String],
		default: () => ([]),
	},

	density: {
		type: String,
		default: 'default',
	},

	debugMode: {
		type: Boolean,
		default: false,
	},

	hideDetails: {
		type: [Boolean, String],
		default: false,
	},

	variant: {
		type: String,
		default: 'input',
		validator: (value) => ['input', 'button'].includes(value),
	},

})

const emit = defineEmits([
	'update:modelValue',
])

const {
	companyTz,
	// guessedTz,
	formatDateTime,
	addTimezoneValue,
} = useMoment()

const {
	personalCompanySettingStartDay,
} = usePersonalCompanySettingsManager()

const modelValueWithoutTimezone = computed(() => {
	if (typeof props.modelValue === 'string') {
		return props.modelValue
	}
	if (Array.isArray(props.modelValue)) {
		return props.modelValue.map((date) => {
			// if (date.includes('+')) {
			// 	return date.split('+')[0]
			// } else if (date.includes('-')) {
			// 	return date.split('-')[0]
			// }
			return formatDateTime(date, undefined, true)
			// return getDateWithoutTimezone(date)
		})
	}
	return props.modelValue
})

const minValueWithoutTimezone = computed(() => {
	if (props.min) {
		return formatDateTime(props.min, undefined, true)
	}
	return props.min
})

const maxValueWithoutTimezone = computed(() => {
	if (props.max) {
		return formatDateTime(props.max, undefined, true)
	}
	return props.max
})

const onUpdateModelValue = (value) => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('AoGreatDateRangePicker onUpdateModelValue', value)
	}
	if (typeof value === 'string') {
		emit('update:modelValue', value)
	}
	if (Array.isArray(value)) {
		emit('update:modelValue', value.map((date) => {
			return addTimezoneValue(date, companyTz.value)
		}))
	}
}

</script>

<style lang="scss">
.app-great-date-range-picker {

	&.variant-button {
		min-width: 210px;

		.app-activator-of-date-range-picker {
			--v-input-padding-top: 2px;
			--v-input-padding-bottom: 2px;

			.v-input__details {
				display: none;
			}

			.v-field {
				--v-field-input-padding-top: 2px;
				--v-field-padding-end: 4px;
				--v-field-input-padding-bottom: 2px;
				--v-field-padding-start: 4px;
				cursor: pointer;
			}

			.v-field__input {
				min-height: 22px;
				height: 100%;
				font-size: 10px;
				text-align: center;
				cursor: pointer;
			}

			.v-field__append-inner {
				padding-top: 4px;
				padding-inline-end: 6px;
				font-size: 12px;
			}

			.v-field__outline {

				&::before {
					--v-field-border-opacity: 1;
					border-width: 1px;
					border-radius: 4px;
					border-color: #d9e3ee;
				}

				&::after {
					--v-field-border-opacity: 1;
					border-width: 2px;
					border-radius: 4px;
					border-color: #d9e3ee;
				}
			}

		}

	}

}
</style>
